// import React, { useState } from 'react';
// import { Link, useNavigate, useLocation } from 'react-router-dom'; // 👈 added useLocation
// import { Menu, X } from 'lucide-react';

// export default function Nav({ user, setUser }) {
//   const nav = useNavigate();
//   const location = useLocation(); // 👈 added
//   const [open, setOpen] = useState(false);

//   function logout() {
//     localStorage.removeItem('token');
//     localStorage.removeItem('user');
//     setUser(null);
//     nav('/login');
//   }

//   // 👇 hide nav on customer order page
//   if (location.pathname.startsWith('/order/')) return null;

//   return (
//     <>
//       {/* Mobile Hamburger */}
//       <button
//         className="fixed top-4 left-4 z-50 bg-gray-800 text-white p-2 rounded-lg shadow-lg md:hidden"
//         onClick={() => setOpen(!open)}
//       >
//         {open ? <X size={20} /> : <Menu size={20} />}
//       </button>

//       {/* Sidebar */}
//       <div
//         className={`fixed top-0 left-0 h-full w-64 bg-white shadow-lg p-4 z-40 transform transition-transform duration-300
//           ${open ? 'translate-x-0 pointer-events-auto' : '-translate-x-full pointer-events-none'} md:translate-x-0 md:pointer-events-auto`}
//       >
//         <h1 className="text-xl font-bold mb-6">SuperBills POS</h1>

//         <nav className="flex flex-col gap-2">
//           <Link to="/" className="px-3 py-2 rounded hover:bg-gray-100" onClick={() => setOpen(false)}>Dashboard</Link>
//           <Link to="/tables" className="px-3 py-2 rounded hover:bg-gray-100" onClick={() => setOpen(false)}>Tables</Link>
//           <Link to="/orders" className="px-3 py-2 rounded hover:bg-gray-100" onClick={() => setOpen(false)}>Orders</Link>
//           <Link to="/menu" className="px-3 py-2 rounded hover:bg-gray-100" onClick={() => setOpen(false)}>Menu</Link>
//           <Link to="/inventory" className="px-3 py-2 rounded hover:bg-gray-100" onClick={() => setOpen(false)}>Inventory</Link>
//           <Link to="/backup" className="px-3 py-2 rounded hover:bg-gray-100" onClick={() => setOpen(false)}>Backup</Link>
//           <Link to="/analytics" className="px-3 py-2 rounded hover:bg-gray-100" onClick={() => setOpen(false)}>Analytics</Link>
//         </nav>

//         <div className="mt-6">
//           {user ? (
//             <div>
//               <p className="text-sm">Hello, {user.name}</p>
//               <p className="text-xs text-gray-500">Role: {user.role}</p>
//               <button
//                 className="mt-3 bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
//                 onClick={logout}
//               >
//                 Logout
//               </button>
//             </div>
//           ) : (
//             <Link
//               to="/login"
//               onClick={() => setOpen(false)}
//               className="mt-3 inline-block bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
//             >
//               Login
//             </Link>
//           )}
//         </div>
//       </div>

//       {/* Overlay for mobile */}
//       {open && (
//         <div
//           className="fixed inset-0 bg-black opacity-50 z-30 md:hidden"
//           onClick={() => setOpen(false)}
//         ></div>
//       )}
//     </>
//   );
// }

import React, { useState, useMemo, useCallback, lazy, Suspense } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

// Lazy load icons
const MenuIcon = lazy(() => import('lucide-react').then(mod => ({ default: mod.Menu })));
const XIcon = lazy(() => import('lucide-react').then(mod => ({ default: mod.X })));

const SidebarLink = React.memo(({ path, label, onClick }) => (
  <Link
    to={path}
    className="px-3 py-2 rounded hover:bg-gray-100"
    onClick={onClick}
  >
    {label}
  </Link>
));

const Sidebar = React.memo(({ open, handleLinkClick, user, logout }) => {
  const links = useMemo(() => [
    { path: '/', label: 'Dashboard' },
    { path: '/tables', label: 'Tables' },
    { path: '/orders', label: 'Orders' },
    { path: '/menu', label: 'Menu' },
    { path: '/inventory', label: 'Inventory' },
    { path: '/backup', label: 'Backup' },
    { path: '/analytics', label: 'Analytics' },
  ], []);

  return (
    <aside
      className={`fixed top-0 left-0 h-full w-64 bg-white shadow-lg p-4 z-40 transform transition-transform duration-300
        ${open ? 'translate-x-0 pointer-events-auto' : '-translate-x-full pointer-events-none'} md:translate-x-0 md:pointer-events-auto`}
    >
      <h1 className="text-xl font-bold mb-6">SuperBills POS</h1>

      <nav className="flex flex-col gap-2">
        {links.map(link => (
          <SidebarLink key={link.path} {...link} onClick={handleLinkClick} />
        ))}
      </nav>

      <div className="mt-6">
        {user ? (
          <div>
            <p className="text-sm">Hello, {user.name}</p>
            <p className="text-xs text-gray-500">Role: {user.role}</p>
            <button
              className="mt-3 bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
              onClick={logout}
            >
              Logout
            </button>
          </div>
        ) : (
          <Link
            to="/login"
            onClick={handleLinkClick}
            className="mt-3 inline-block bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
          >
            Login
          </Link>
        )}
      </div>
    </aside>
  );
});

export default function Nav({ user, setUser }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const logout = useCallback(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    navigate('/login');
  }, [navigate, setUser]);

  const handleLinkClick = useCallback(() => setOpen(false), []);

  // Hide nav on customer order page
  if (location.pathname.startsWith('/order/')) return null;

  return (
    <>
      {/* Mobile Hamburger */}
      <button
        className="fixed top-4 left-4 z-50 bg-gray-800 text-white p-2 rounded-lg shadow-lg md:hidden"
        onClick={() => setOpen(prev => !prev)}
      >
        <Suspense fallback={null}>
          {open ? <XIcon size={20} /> : <MenuIcon size={20} />}
        </Suspense>
      </button>

      {/* Sidebar */}
      <Sidebar
        open={open}
        handleLinkClick={handleLinkClick}
        user={user}
        logout={logout}
      />

      {/* Mobile Overlay */}
      {open && <div className="fixed inset-0 bg-black opacity-50 z-30 md:hidden" onClick={handleLinkClick}></div>}
    </>
  );
}

